"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentsJobName = void 0;
var TournamentsJobName;
(function (TournamentsJobName) {
    TournamentsJobName["Finished"] = "finished";
    TournamentsJobName["CheckIn"] = "checkin";
    TournamentsJobName["Canceled"] = "canceled";
    TournamentsJobName["NextMatchStarted"] = "next_match_started";
    TournamentsJobName["NextLowerMatchStarted"] = "next_lower_match_started";
    TournamentsJobName["NewRoundCheckin"] = "new_round_checkin";
    TournamentsJobName["MatchGameExpired"] = "match_game_expired";
    TournamentsJobName["JoinMatchGameTimerExpired"] = "join_match_game_timer_expired";
})(TournamentsJobName = exports.TournamentsJobName || (exports.TournamentsJobName = {}));
//# sourceMappingURL=tournaments-job-name.js.map